import React, { useState } from "react";
import { Modal, Form, Button, Input, message, Select } from "antd";
import Service from "./../../../utils/apiOpen";

function ThemSanPham(props) {
  const [form] = Form.useForm();
  const formRef = React.createRef();
  const [errMess, setErrMess] = useState('');
  const [loading, setLoading] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);


  const onFinish = (val) => {
    form
      .validateFields()
      .then(async (values) => {
        // console.log(values)
        Create();
      })
      .catch((err) => {
        console.error("err:", err);
      });
  };

  const Create = async () => {
    setLoading(true);
    const dataForm = {
      "providerId": selectedProduct?.providerId || undefined,
      "providerCode": selectedProduct?.providerCode || undefined,
      "productId": selectedProduct.id || undefined,
      "productCode": selectedProduct.code || undefined,
      "pbpId": selectedProduct.pbpId || undefined,
      "pbpCode": selectedProduct.pbpCode || undefined,
      "category": selectedProduct.category || undefined
    }
    await Service.openApiCall("POST", `/v1/affiliate/portal/product`, dataForm)
      .then((res) => {
        setLoading(false);
        let data = res?.data;
        if (data.success) {
          props.MessageSucces('Thêm sản phẩm thành công');
          form.resetFields();
          props.getList();
          setTimeout(() => {
            props.handleCancel();
          }, 2000);
          // setData(data?.data?.data);
          // setTotal(data?.data?.total);
        }
      })
      .catch((err) => {
        setLoading(false);
        if (err?.response) {
          message.error(
            err?.response?.data?.error?.statusCode + ' | ' +
            (err?.response?.data?.error?.code === 'PRODUCTS_HUB_CONFLICT' ? 'Tên sản phẩm đã tồn tại' : err?.response?.data?.message));
        }
      });
  };

  return (
    <Modal
      title={<div style={{ fontSize: '16px', fontWeight: '600', color: '#003478', borderBottom: '1px solid #D2D2D2', paddingBottom: 15 }}>Thêm sản phẩm</div>}
      open={true}
      centered
      onCancel={props.handleCancel}
      bodyStyle={{ padding: '15px 0px', fontFamily: '"Roboto", sans-serif', background: '#ffffff', borderRadius: 12 }} style={{ top: 20, maxWidth: 400 }}
      footer={[
        <Button
          loading={loading}
          key="submit"
          type="primary"
          style={{ backgroundColor: '#0B7CE4', border: '1px', borderRadius: '5px' }}
          // onClick={handleOk}
          onClick={onFinish}
        >
          Tiếp tục
        </Button>
      ]}
    >
      <Form
        form={form}
        layout="vertical"
        style={{ gap: '0px', display: 'flex', flexDirection: 'column' }}
        requiredMark={false}
      >
        <Form.Item
          style={{ padding: 0, marginBottom: 15, marginTop: -5 }}
          name="productName"
          label={<span style={{ color: '#212529', fontWeight: '400', fontSize: '15px', color: '#969696' }}>Tên sản phẩm  <span style={{ color: 'red' }}>*</span> </span>}
          rules={[{ required: true, message: 'Vui lòng chọn sản phẩm!' }]}
        >
          <Select
            style={{ width: '100%', borderRadius: '8px' }}
            allowClear
            showSearch={true}
            size="large"
            placeholder={<span style={{ color: '#343a40' }}>Chọn sản phẩm</span>}
            options={props?.config?.products?.map(product => ({
              value: product.pbpId,
              label: product.title,
            }))}
            filterOption={(input, node) => {
              const normalize = str =>
                str?.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
              return normalize(node?.label || '').includes(normalize(input));
            }}
            onChange={(value) => {
              const selected = props?.config?.products.find(p => p.pbpId === value);
              setSelectedProduct(selected || null);
              if (selected) {
                form.setFieldsValue({
                  gcCode: selected.gcCode || '',
                  url: selected.url,
                  commissionRate: selected.commissionRate,
                  categoryTitle: selected.categoryTitle,
                  providerTitle: selected.providerTitle
                });
              } else {
                form.resetFields(['gcCode', 'url', 'commissionRate', 'categoryTitle', 'providerTitle']);
              }
            }}
          />
        </Form.Item>
        <Form.Item
          style={{ padding: 0, marginBottom: 15 }}
          name="gcCode"
          label={<span style={{ color: '#212529', fontWeight: '400', fontSize: '15px', color: '#969696' }}> Mã sản phẩm <span style={{ color: 'red' }}>*</span></span>}
        // rules={[{ required: true, message: 'Vui lòng nhập mã sản phẩm!' }]}
        >
          <Input
            placeholder="Mã sản phẩm"
            size="large"
            disabled
            style={{ borderRadius: '8px' }}
          />
        </Form.Item>

        <Form.Item
          style={{ padding: 0, marginBottom: 15 }}
          name="url"
          label={<span style={{ color: '#212529', fontWeight: '400', fontSize: '15px', color: '#969696' }}> Link sản phẩm <span style={{ color: 'red' }}>*</span></span>}
        // rules={[{ required: true, message: 'Vui lòng nhập link sản phẩm!' }]}
        >
          <Input
            placeholder="Dán link sản phẩm"
            size="large"
            disabled
            style={{ borderRadius: '8px' }}
          />
        </Form.Item>

        <Form.Item
          style={{ padding: 0, marginBottom: 15 }}
          name="commissionRate"
          label={<span style={{ color: '#212529', fontWeight: '400', fontSize: '15px', color: '#969696' }}> Tỉ lệ hoa hồng <span style={{ color: 'red' }}>*</span></span>}
        // rules={[{ required: true, message: 'Vui lòng nhập tỉ lệ hoa hồng!' }]}
        >
          <Input
            placeholder="Nhập tỉ lệ hoa hồng"
            size="large"
            disabled
            style={{ borderRadius: '8px' }}
            addonAfter={<span style={{ color: '#969696' }}>%</span>}
          />
        </Form.Item>

        <Form.Item
          style={{ padding: 0, marginBottom: 15 }}
          name="categoryTitle"
          label={<span style={{ color: '#212529', fontWeight: '400', fontSize: '15px', color: '#969696' }}> Loại bảo hiểm <span style={{ color: 'red' }}>*</span></span>}
        // rules={[{ required: true, message: 'Vui lòng chọn loại bảo hiểm!' }]}
        >
          <Select
            style={{ width: '100%', borderRadius: '8px' }}
            allowClear
            size="large"
            disabled
            placeholder={<span style={{ color: '#969696' }}>Chọn loại bảo hiểm</span>}
          // options={[{ value: '1', label: 'Bảo Minh' }]}
          />
        </Form.Item>

        <Form.Item
          style={{ padding: 0, marginBottom: 0 }}
          name="providerTitle"
          label={<span style={{ color: '#212529', fontWeight: '400', fontSize: '15px', color: '#969696' }}> Nhà bảo hiểm <span style={{ color: 'red' }}>*</span></span>}
        // rules={[{ required: true, message: 'Vui lòng chọn nhà bảo hiểm' }]}
        >
          <Select
            style={{ width: '100%', borderRadius: '8px', }}
            allowClear
            size="large"
            disabled
            placeholder={<span style={{ color: '#969696' }}>Chọn nhà bảo hiểm</span>}
          // options={[{ value: '1', label: 'Bảo Minh' }]}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default ThemSanPham;
